// extracted by mini-css-extract-plugin
export var chevron = "_35-2";
export var chevronCollapsed = "_35-3";
export var collapsibleHeader = "_35-1";
export var container = "_35-0";